import { render } from "./LuxMessage.vue?vue&type=template&id=a8be5450&scoped=true&ts=true"
import script from "./LuxMessage.vue?vue&type=script&lang=ts"
export * from "./LuxMessage.vue?vue&type=script&lang=ts"

import "./LuxMessage.vue?vue&type=style&index=0&id=a8be5450&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8be5450"]])

export default __exports__